/*
 * This file is part of the https://gitlab-intern.easd-support.de/easd/p26s26_energie_watchdog project.
 *
 * (c) 2026 EA Systems Dresden GmbH
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import { Gauge } from 'lucide-react';

/* Import configuration */
import {APP_NAME_1, APP_NAME_2} from "@/config/app";

/* Import types */
import type { AppLanguage } from '@/i18n/translations';

interface AppBrandProps {
    className?: string;
}

interface AppBrandV2Props {
    className?: string;
}

interface AppLoginBrandProps {
    className?: string;
    language: AppLanguage;
    theme: 'light' | 'dark';
}

function AppBrand({ className }: AppBrandProps) {
    return (
        <span className={`app-brand${className ? ` ${className}` : ''}`}>
            <Gauge
                className="h-5 w-5 shrink-0"
                aria-hidden="true"
                style={{ color: '#489e2c' }}
            />
            <span className="app-brand__mark">
                <span className="app-brand__energy">{APP_NAME_1}</span>
                <span className="app-brand__watchdog">{APP_NAME_2}</span>
            </span>
        </span>
    );
}

export function AppBrandV2({ className }: AppBrandV2Props) {
    return (
        <span
            className={`app-brand-v2${className ? ` ${className}` : ''}`}
        >
            <img
                className="app-brand-v2__image app-brand-v2__image--light"
                src="/logo/encustos.light.svg"
                alt="EnCustos"
            />
            <img
                className="app-brand-v2__image app-brand-v2__image--dark"
                src="/logo/encustos.dark.svg"
                alt=""
                aria-hidden="true"
            />
        </span>
    );
}

export function AppLoginBrand({ className, language, theme }: AppLoginBrandProps) {
    const languageSuffix = language === 'de' ? '' : `.${language}`;

    return (
        <img
            className={`app-login-brand${className ? ` ${className}` : ''}`}
            src={`/logo/en-observe-logo-text${languageSuffix}.${theme}.svg`}
            alt="EnObserve"
        />
    );
}

export default AppBrand;
